module.exports = __webpack_public_path__ + "img/card-content-2.bdac01e8.png";